import { render, staticRenderFns } from "./LicenseConfKeyEdition.vue?vue&type=template&id=bcf50cc4&scoped=true"
import script from "./LicenseConfKeyEdition.vue?vue&type=script&lang=js"
export * from "./LicenseConfKeyEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf50cc4",
  null
  
)

export default component.exports